<template>
	<div class='mb-3 alert alert-danger fade show'>
		{{message}}
	</div>
</template>

<script>
export default {
	name: "ErrorMessage",
	props: {
		title: String,
		message: String
	}
};
</script>